import { useEffect, useState } from "react";
import { CheckOutlined } from "@ant-design/icons";
import { useSelector, useDispatch } from "react-redux";
import connectionActions from "../../../redux/connections/actions"
import styles from "./style.module.scss";
import userImage from "../../../assets/images/user";


const LeftSideComponent = () => {
  const dispatch = useDispatch()
  const {
    user,
    creditzIds = [],
    connections = [],
    pending = [],
    sent = [],
  } = useSelector((state) => ({
    user: state.users.user,
    creditzIds: state.users.creditzIds,
    connections: state.connection.connections,
    pending: state.connection.pending,
    sent: state.connection.sent,
  }));
  const [canConnect, setCanConnect] = useState(true);
  const [isPending, setPending] = useState(false);
  useEffect(()=>{
    dispatch({
      type: connectionActions.GET_NOTIFICATION_CONNECTION
    })
    dispatch({
      type: connectionActions.GET_SENT_REQUESTS
    })
    dispatch({
      type: connectionActions.GET_CONNECTIONS_LIST
    })
  },[])

  useEffect(() => {
    const isSent = sent.findIndex((a) => a.user?.uid === user.uid) >= 0;
    const isP = pending.findIndex((a) => a.user?.uid === user.uid) >= 0;
    const isConnected = connections.findIndex((a) => a.uid === user.uid) >= 0;
    setPending(isP || isSent);
    setCanConnect(!isConnected && !(isP || isSent));
  }, [pending, connections, sent, user]);

  const connect = () => {
    dispatch({
      type: connectionActions.SEND_CONNECT_REQURST,
      payload: {
        userId: user.uid,
      },
    });
  };

  return (
    <>
      <div className={styles.leftSideComponent}>
        <div
          className={styles.avatarContainer}
          style={
            user.coverImageUrl
              ? { backgroundImage: `url(${user.coverImageUrl})` }
              : {}
          }
        />
        <div className={styles.thumb}>
          <img src={user?.profileImageUrl || userImage()} alt="userImage" />
          {user.isVerified && (
            <div className={styles.selected}>
              <CheckOutlined style={{ color: "#C86DD7" }} />
            </div>
          )}
        </div>
        <div className={styles.infoContainer}>
          <p className={styles.name}>{user.username}</p>
          <div className={styles.artist}>
            <span>{user.accountType}</span>
          </div>
          <div className={styles.genre}>
            {user.genre &&
              user.genre
                .split(",")
                .map((item) => <span key={item}>{item}</span>)}
          </div>
          <div className={styles.statisticsContainer}>
            <div className={styles.statistics}>
              <div className={styles.item}>
                {user.connect_counts} <br /> Connections
              </div>
              <div className={styles.vertical} />
              <div className={styles.item}>
                {creditzIds.length} <br /> Credits
              </div>
            </div>
          </div>
          <div className={styles.bottomContainer}>
            <div className={styles.statusContainer}>
              <div className={styles.status}>Status</div>
              <div className={styles.value}>{user.status}</div>
            </div>
            {user.managementType && (
              <div className={styles.status}>{user.managementType}</div>
            )}
            {user.managementUser && (
              <div className={styles.username}>@{user.managementUser}</div>
            )}
          </div>
        </div>
      </div>
      {canConnect && <button className={styles.connect_button} onClick={connect}>Connect</button>}
      {isPending && <button className={styles.pending_button}>Pending</button>}
    </>
  );
};

export default LeftSideComponent;
